<div class="time-picker-container">
  <ed-input-field class="w-full">
    <input
      [disabled]="isDisabled"
      [class.ng-invalid]="invalid"
      [class.ng-touched]="invalid"
      type="text"
      mask="00:00"
      (focus)="toggleTimePickerData()"
      [(ngModel)]="value"
      (ngModelChange)="onValueChange($event)"
      (keypress)="onKeyPress($event)"
      (focusout)="focusOut($event)"
      edInput
      #timePickerInput
    />
  </ed-input-field>
  <mat-icon class="clock-icon" svgIcon="clock"></mat-icon>
  <ng-template #timePickerData>
    <div
      [id]="timePickerDataId"
      class="my-1 p-2 rounded-lg bg-white shadow-sm border-2 border-grey-10"
      [style.width.px]="inputWidth"
    >
      <div class="max-h-[15rem] overflow-y-scroll">
        @for (time of timeList; track time) {
        <div
          class="px-3 py-2 rounded-xl hover:bg-[#DDDFE6] cursor-pointer text-left font-edenred w-full flex justify-between items-center"
          (click)="onTimeClick(time)"
        >
          <span class="text-base">{{ time }}</span>
          <mat-icon class="arrow-right" svgIcon="arrow-right-2"></mat-icon>
        </div>
        }
      </div>
    </div>
  </ng-template>
</div>
